import { IconProps } from "../../models/Icon";

export function SwapIcon({ size = 20, color = "#000", opacity="1"}: IconProps) {
    return(
        <svg 
            width={size} 
            height={size} 
            viewBox={`0 0 ${size} ${size}`} 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M13.9981 9.42913H1.57128C1.49271 9.42913 1.42842 9.49342 1.42842 9.57199V10.6434C1.42842 10.722 1.49271 10.7863 1.57128 10.7863H12.3784L9.80164 14.0541C9.72842 14.147 9.79449 14.2863 9.91414 14.2863H11.2088C11.2963 14.2863 11.3784 14.247 11.4338 14.1773L14.4481 10.3541C14.7427 9.97913 14.4766 9.42913 13.9981 9.42913ZM14.4284 5.21484H3.62128L6.19807 1.94699C6.27128 1.85413 6.20521 1.71484 6.08557 1.71484H4.79092C4.70342 1.71484 4.62128 1.75413 4.56592 1.82377L1.55164 5.64699C1.25699 6.02199 1.52306 6.57199 1.99985 6.57199H14.4284C14.507 6.57199 14.5713 6.5077 14.5713 6.42913V5.3577C14.5713 5.27913 14.507 5.21484 14.4284 5.21484Z" 
                fill={color} 
                fillOpacity={opacity}
            />
        </svg>
    )
}